import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { OtherService } from 'src/app/Service/other.service';

import axios from 'src/app/Service/axios';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import Feature from 'ol/Feature';

import { Icon, Style } from 'ol/style';

import { BingMaps, XYZ } from 'ol/source';

import TileLayer from 'ol/layer/Tile';

import VectorLayer from 'ol/layer/Vector';

import VectorSource from 'ol/source/Vector';

import * as olProj from 'ol/proj';

import { Point } from 'ol/geom';

import Vector from 'ol/source/Vector';

import Map from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

import { NotificationService } from 'src/app/Service/notification.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { ActivatedRoute, Router } from '@angular/router';

declare let $: any;

import momentJalaali from 'moment-jalaali';

import * as moment from 'moment-jalaali'

@Component({

  selector: 'app-trips',

  templateUrl: './official-trips.component.html',

  styleUrls: ['./official-trips.component.css']

})

export class OfficialTripsComponent implements OnInit {

  menuType: number = 0;

  isLoading: boolean = false;

  isPassengerLoading: boolean = false;

  tripImportance: any;

  vehicleTypes: any;

  tripReasons: any;

  filteredPassenger: any;

  passengers: any;

  geo: any = {};

  origin: any;

  destination: any;

  tripID: any;

  source: any;

  vector: any;

  mapMode: any;

  bExclusive: boolean = false;

  bHaveReturn: boolean = false;

  bMissionary: boolean = false;

  bTravel: boolean = false;

  bStaffTravel: boolean = false;

  bManageTravel: boolean = false;

  isBusyRoutes: boolean = false;

  lst_TripSAD: any = [];

  lst_TripSAD_Search: any = [];

  otherPassengers: object[] = [];

  layers: any = [];

  map: any;

  mapHeader: any;

  hasQuery: boolean = false;

  bLatChange: boolean = false;

  bLonChange: boolean = false;

  clockTime!: string;

  obj_TripSAD: any = {}

  tripDet: FormGroup = this.formBuilder.group({

    safir: new FormControl(''),

    safirFamily: new FormControl(''),

    strFullName: new FormControl(''),

    strPassengersMobile: new FormControl(''),

    tripiPassenger: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    otherp: new FormControl(''),

    tripDescription: new FormControl(''),

    strEndMissionDate: new Date().valueOf(),

    tripRes: new FormControl('-1', Validators.min(0)),

    tripImp: new FormControl('-1', Validators.min(0)),

    vehicleUs: new FormControl('-1', Validators.min(0)),

    bCheckByQRCode: new FormControl(false),

  })

  path: FormGroup = this.formBuilder.group({

    origin: new FormControl('', Validators.required),

    destination: new FormControl(''),

    olatIn: new FormControl('', Validators.required),

    dlatIn: new FormControl('', Validators.required),

    olongIn: new FormControl('', Validators.required),

    dlongIn: new FormControl('', Validators.required),

    addressBar: new FormControl(''),

    temp_mapMode: new FormControl(''),

    temp_dlatIn: new FormControl(''),

    temp_dlongIn: new FormControl(''),

    temp_olatIn: new FormControl(''),

    temp_olongIn: new FormControl(''),

  })

  dates: FormGroup = this.formBuilder.group({
    OtripDate: new Date().valueOf(),
  });

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  @Input() appMenuType!: number;

  @Output() tripModal_Close = new EventEmitter<boolean>();

  constructor(

    public otherServices: OtherService,

    private formBuilder: FormBuilder,

    private notificationService: NotificationService,

    private gurdService: GurdServiceService,

    private route: ActivatedRoute,

    private _router: Router

  ) { }

  ngOnInit(): void {

    this.clockTime = momentJalaali().add(30, 'minutes').format('HH:mm');

    this.route.url.subscribe((segment) => {

      // سفر برون سازمانی 

      if (segment[0]?.path == 'office-travel' || this.appMenuType == -1) { // 1

        this.bTravel = true;

        this.isBusyRoutes = false;

        this.menuType = 0;

        // setTimeout(() => {

        //   $('.clockpicker').clockpicker({

        //     donetext: 'top',

        //     align: 'top',

        //     autoclose: true,

        //   });

        // }, 2000);

      }

      // سفر های پرسنل من 

      else if (segment[0].path == 'staff-travel') { // 2

        this.bStaffTravel = true;

        this.menuType = 3;

      }

      // مدیریت سفرها 

      else if (segment[0].path == 'manage-travel') { // 3

        this.bManageTravel = true;

        this.menuType = 4;

      }

      // اتوماسیون اداری

      else {

        this.setType(4);

      }

    })

    this.getTripImportance();

    this.getVehicleTypes();

    this.getTripReasons();

    // this.getPassengers();

  }

  ngAfterContentChecked() {

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });


  }

  resetForm(isClose?: boolean) {

    this.tripDet.patchValue({

      safir: "",

      safirFamily: "",

      strFullName: "",

      strPassengersMobile: "",

      tripiPassenger: "",

      strMobile: "",

      otherp: "",

      tripDescription: "",

      tripRes: "-1",

      tripImp: "-1",

      vehicleUs: "-1",

    })

    this.path.patchValue({

      origin: "",

      destination: "",

      olatIn: "",

      dlatIn: "",

      olongIn: "",

      dlongIn: "",

      addressBar: "",

      temp_mapMode: "",

      temp_dlatIn: "",

      temp_dlongIn: "",

      temp_olatIn: "",

      temp_olongIn: "",

    })

    this.clockTime = momentJalaali().add(30, 'minutes').format('HH:mm');

    this.resetSafir();

    if (isClose) this.tripModal_Close.emit(true);

  }

  setDropDown(id: any, val: any) {
    switch (id) {
      case 0:
        this.tripDet.controls['tripRes'].setValue(val);

        break;
      case 1:
        this.tripDet.controls['tripImp'].setValue(val);
        break;
      case 2:
        this.tripDet.controls['vehicleUs'].setValue(val);
        break;
      default:
        break;
    }

  }

  async sabtTrip() {

    var Etime = document.getElementById("Etime") as any;

    if (this.tripDet.valid && this.path.valid) {

      let model = this.otherServices.stringNumberToNumber({

        strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

        iPassenger: this.tripDet.get('tripiPassenger')?.value, // کلید اختصاصی متقاضی

        strMobile: this.tripDet.get('strMobile')?.value, // شماره موبایل متقاضی

        strName: this.tripDet.get('tripiPassenger')?.value == 0 ? this.tripDet.get('safir')?.value : '', // نام متقاضی

        strFamily: this.tripDet.get('tripiPassenger')?.value == 0 ? this.tripDet.get('safirFamily')?.value : '', // فامیل متقاضی

        strPassengersName: this.otherPassengers.map((el: any) => el.strName).toString(),

        fsLat: this.path.get('olatIn')?.value,

        fsLon: this.path.get('olongIn')?.value,

        fDLat: this.path.get('dlatIn')?.value,

        fDLon: this.path.get('dlongIn')?.value,

        bMissionary: this.bMissionary,

        bExclusive: this.bExclusive,

        bHaveReturn: this.bHaveReturn,

        strSourceAddress: this.path.get('origin')?.value,

        strDestinationAddress: this.path.get('destination')?.value,

        strComment: this.tripDet.get('tripDescription')?.value,

        strTripDate: this.dates.get('OtripDate')?.value,

        strTripTime: Etime.value,

        tiTripImportance: this.tripDet.get('tripImp')?.value,

        tiTripReason: this.tripDet.get('tripRes')?.value,

        MobileType: this.tripDet.get('vehicleUs')?.value,

        strPassengersMobile: this.tripDet.get('strPassengersMobile')?.value,

        strEndMissionDate: this.bMissionary ? this.tripDet.get('strEndMissionDate')?.value : '',

        bCheckByQRCode: this.tripDet.get('bCheckByQRCode')?.value,

      })

      $.confirm({

        title: `آیا از ثبت سفر اطمینان دارید ؟`,

        content: '',

        type: 'green',

        buttons: {

          ok: {

            text: "ثبت",

            btnClass: 'btn-success',

            keys: ['enter'],

            action: async () => {

              let res: any = (await axios.post(`OffitialTrip_Save`, model));

              let resParse = JSON.parse(res.data.toString());

              if (resParse.iResult == 0) return this.notificationService.showError(resParse.strError)

              if (resParse[0].iOfficialTrip) {

                this.tripID = resParse[0].iOfficialTrip;

                $('#confirmationMdl').modal('show');

              }

              else {

                this.notificationService.showError(resParse[0].strError)

              }

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    else {

      this.notificationService.showError('لطفا فرم را با دقت کامل کنید');

    }

  }

  closeTrip() {

    let model = this.otherServices.stringNumberToNumber({

      iPassenger: this.tripDet.get('tripiPassenger')?.value, // کلید اختصاصی متقاضی

      strMobile: this.tripDet.get('strMobile')?.value, // شماره موبایل متقاضی

      strName: this.tripDet.get('tripiPassenger')?.value == 0 ? this.tripDet.get('safir')?.value : '', // نام متقاضی

      strFamily: this.tripDet.get('tripiPassenger')?.value == 0 ? this.tripDet.get('safirFamily')?.value : '', // فامیل متقاضی

      fsLat: this.path.get('olatIn')?.value,

      fsLon: this.path.get('olongIn')?.value,

      fDLat: this.path.get('dlatIn')?.value,

      fDLon: this.path.get('dlongIn')?.value,

    })

    if (model.iPassenger != '' || model.strFamily != '' || model.strMobile != '' || model.strName != '' || model.fDLat != '' || model.fsLat != '') {

      $.confirm({

        title: `آیا قصد بازگشت بدون ذخیره اطلاعات را دارید ؟`,

        content: '',

        type: 'red',

        buttons: {

          ok: {

            text: "بازگشت",

            btnClass: 'btn-danger',

            keys: ['enter'],

            action: async () => {

              this.resetForm(true)

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    else {

      this.resetForm(true)

    }

  }

  newOpenMap = (mode: number, checkText?: 'bLatChange' | 'bLonChange') => {

    if (checkText && this[checkText]) {

      this[checkText] = false;

      let strAddress = checkText == 'bLonChange' ? this.path.get('origin')?.value : this.path.get('destination')?.value

      this.getLocationGeocoding(0, checkText == 'bLatChange' ? 1 : 0, strAddress);

    }

    else {

      this.mapMode = mode;

      mode == 0 ? this.mapHeader = 'ثبت مبدأ' : this.mapHeader = 'ثبت مقصد';

      $('#maplat').modal('show');

      setTimeout(() => {
        if (this.map) {
          this.map.setTarget(null);
        }

        this.source = new VectorSource({ wrapX: false });

        this.vector = new VectorLayer({
          source: this.source,
        });

        var iconStyle = new Style({
          image: new Icon(({
            anchor: [0, 46],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            size: [48, 48],
            opacity: 1,
            src: '../../assets/Img/marker4.png'
          }))
        });


        if (this.bOfflineMap) {

          this.layers.push(

            new TileLayer({

              source: new XYZ({

                // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' // 

              }),

            })

          );

        }

        else {

          const styles = [

            'AerialWithLabelsOnDemand',

          ];

          let i, ii;

          for (i = 0, ii = styles.length; i < ii; ++i) {

            this.layers.push(

              new TileLayer({

                visible: false,

                preload: Infinity,

                source: new BingMaps({

                  // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                  imagerySet: styles[i],

                }),

              }),

            );
          }

          this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


        }

        if (this.path.get('olatIn')?.value != '' && this.path.get('olongIn')?.value != '' && this.mapMode == 0) {
          this.map = new Map({
            layers: this.layers,
            target: 'map',
            controls: [],
            view: new View({
              center: olProj.fromLonLat([this.path.get('olongIn')?.value, this.path.get('olatIn')?.value]),
              zoom: 18,
            }),
          });

          var iconGeometry = new Point(olProj.fromLonLat([this.path.get('olongIn')?.value, this.path.get('olatIn')?.value]))

          var iconFeature = new Feature({
            geometry: iconGeometry,
          });

          iconFeature.setStyle(iconStyle);
          var vectorSource = new Vector({
            features: [iconFeature]
          });

          var dinamicPinLayer = new VectorLayer({
            source: vectorSource
          });

          this.map.addLayer(dinamicPinLayer);

        }

        else if (this.path.get('dlatIn')?.value != '' && this.path.get('dlongIn')?.value != '' && this.mapMode == 1) {
          this.map = new Map({
            layers: this.layers,
            target: 'map',
            controls: [],
            view: new View({
              center: olProj.fromLonLat([this.path.get('dlongIn')?.value, this.path.get('dlatIn')?.value]),
              zoom: 18,
            }),
          });

          var iconGeometry = new Point(olProj.fromLonLat([this.path.get('dlongIn')?.value, this.path.get('dlatIn')?.value]))

          var iconFeature = new Feature({
            geometry: iconGeometry,
          });

          iconFeature.setStyle(iconStyle);
          var vectorSource = new Vector({
            features: [iconFeature]
          });

          var dinamicPinLayer = new VectorLayer({
            source: vectorSource
          });

          this.map.addLayer(dinamicPinLayer);

        }

        else {

          this.map = new Map({
            layers: this.layers,
            target: 'map',
            controls: [],
            view: new View({
              center: olProj.fromLonLat([51.3833554, 35.6770113]),
              zoom: 13,
            }),
          });
        }

        this.map.on('click', (e: any) => {

          if (e.dragging) return;

          var coords = olProj.toLonLat(e.coordinate);

          if (this.mapMode == 0) { // مبداء

            this.path.controls['temp_mapMode'].setValue(0)

            this.path.controls['temp_olatIn'].setValue(coords[1])

            this.path.controls['temp_olongIn'].setValue(coords[0])

            this.setReverseGeocode(this.path.controls['temp_olatIn'].value, this.path.controls['temp_olongIn'].value);

          }

          else if (this.mapMode == 1) { // مقصد

            this.path.controls['temp_mapMode'].setValue(1)

            this.path.controls['temp_dlatIn'].setValue(coords[1])

            this.path.controls['temp_dlongIn'].setValue(coords[0])

            this.setReverseGeocode(this.path.controls['temp_dlatIn'].value, this.path.controls['temp_dlongIn'].value);


          }

          var iconGeometry = new Point(e.coordinate);

          var iconFeature = new Feature({

            geometry: iconGeometry,

            properties: {

              name: 'mapMarker'

            }

          });

          iconFeature.setStyle(iconStyle);

          var vectorSource = new Vector({

            features: [iconFeature]

          });

          var dinamicPinLayer = new VectorLayer({

            source: vectorSource

          });

          this.map.getLayers().forEach((layer: VectorSource) => {

            // if (layer.getKeys().length < 11) {

            //   this.map.removeLayer(layer);

            // }

            let layers = this.map.getLayers().getArray();

            for (const item of layers) {

              if (item.getKeys().length < 11) {

                this.map.removeLayer(item);

              }

            }

          });

          this.map.addLayer(dinamicPinLayer);

        })

        this.map.on('pointermove', (e: any) => {
          var pixel = this.map.getEventPixel(e.originalEvent);
          var hit = this.map.hasFeatureAtPixel(pixel);
          this.map.getViewport().style.cursor = 'pointer';
        });

      }, 500);

    }

  }

  confirmMap() {

    if (this.mapMode == 0) {

      this.path.controls['olatIn'].setValue(this.path.get('temp_olatIn')?.value)

      this.path.controls['olongIn'].setValue(this.path.get('temp_olongIn')?.value);

      this.path.controls['origin'].setValue(this.path.get('addressBar')?.value)

      this.origin.strAddress = this.path.get('addressBar')?.value; // مبدا

    }

    else {


      this.path.controls['dlatIn'].setValue(this.path.get('temp_dlatIn')?.value)

      this.path.controls['dlongIn'].setValue(this.path.get('temp_dlongIn')?.value);

      this.path.controls['destination'].setValue(this.path.get('addressBar')?.value)

      this.destination.strAddress = this.path.get('addressBar')?.value; // مقصد


    }

    this.path.controls['addressBar'].setValue('')

  }

  async setReverseGeocode(lat: any, long: any) {

    let res = (await axios.post(`ReverseGeocoding_FleetYar`, {

      'fLat': lat,

      'fLon': long

    }));

    this.path.controls['addressBar'].setValue(res.data.strAddress);

  }

  async getLocationGeocoding(source: any, int: any, value: any, checkText?: 'bLatChange' | 'bLonChange') {

    setTimeout(() => {

      if (checkText) {

        this[checkText] = false;

      }

    }, 100);

    var model = this.otherServices.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      strAddress: value

    })

    let res = JSON.parse((await axios.post(`Geocoding_FleetYar`, model)).data.toString());

    if (res.iResult == -1) return this.notificationService.showError(res.strComment);

    if (source == 1 && int == 0) this.path.controls['origin'].setValue(model.strAddress); // مبدا

    if (source == 1 && int == 1) this.path.controls['destination'].setValue(model.strAddress); // مقصد

    if (int == 0) {

      this.origin = res;

      this.path.controls['olatIn'].setValue(this.origin.fLat)

      this.path.controls['olongIn'].setValue(this.origin.fLon)

      this.path.controls['addressBar'].setValue(value);

      this.newOpenMap(0);

    }

    else {

      this.destination = res

      this.path.controls['dlatIn'].setValue(this.destination.fLat)

      this.path.controls['dlongIn'].setValue(this.destination.fLon)

      this.path.controls['addressBar'].setValue(value);

      this.newOpenMap(1);

    }

    if (source == 1) {

      this.map.getLayers().forEach((layer: VectorSource) => {

        // if (layer.getKeys().length < 11) {

        //   this.map.removeLayer(layer);

        // }

        let layers = this.map.getLayers().getArray();

        for (const item of layers) {

          if (item.getKeys().length < 11) {

            this.map.removeLayer(item);

          }

        }

      });

      var iconStyle = new Style({
        image: new Icon(({
          anchor: [0, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          size: [48, 48],
          opacity: 1,
          src: '../../assets/Img/marker4.png'
        }))
      });

      var iconGeometry;

      this.mapMode == 0 ?

        iconGeometry = new Point(olProj.fromLonLat([this.path.get('olongIn')?.value, this.path.get('olatIn')?.value])) :

        iconGeometry = new Point(olProj.fromLonLat([this.path.get('dlongIn')?.value, this.path.get('dlatIn')?.value]))

      var iconFeature = new Feature({

        geometry: iconGeometry,

      });

      iconFeature.setStyle(iconStyle);

      var vectorSource = new Vector({

        features: [iconFeature]

      });

      var dinamicPinLayer = new VectorLayer({
        source: vectorSource
      });

      this.map.addLayer(dinamicPinLayer);

      this.mapMode == 0 ?

        this.map.getView().setCenter(olProj.transform([this.path.get('olongIn')?.value, this.path.get('olatIn')?.value], 'EPSG:4326', 'EPSG:3857')) :

        this.map.getView().setCenter(olProj.transform([this.path.get('dlongIn')?.value, this.path.get('dlatIn')?.value], 'EPSG:4326', 'EPSG:3857'))

      this.map.getView().getZoom() == 13 ? this.map.getView().animate({

        zoom: this.map.getView().getZoom() + 5,

        duration: 250

      }) : this.map.getView().animate({

        zoom: this.map.getView().getZoom() + 0,

        duration: 250

      })

    }

  }

  addToOtherPassengers(operation: number, passenger: any) {

    if (operation == 0) {

      this.otherPassengers.push({

        'strName': passenger,

      })

      this.otherPassengers = this.otherPassengers.map((item, index) => ({ ...item, 'id': index + 1 }));

    }

    else {

      this.otherPassengers = this.otherPassengers.filter((x: any) => x.id !== passenger.id)

    }

  }

  resetSafir() {
    this.tripDet.controls['safir'].setValue('');
    this.tripDet.controls['tripiPassenger'].setValue('');
    (document.getElementById('tripPassenger') as HTMLInputElement).readOnly = false;
  }

  selectedSafir(person: any) {

    this.hasQuery = false;

    this.filteredPassenger = [];

    this.tripDet.controls['tripiPassenger'].setValue(person.iPassenger);

    this.tripDet.controls['safir'].setValue(person.strFullName);

    this.tripDet.controls['strMobile'].setValue(person.strMobile);

    setTimeout(() => {

      (document.getElementById('tripPassenger') as HTMLInputElement).readOnly = true;

    }, 10);

  }

  newSafir(strName?: string) {

    this.hasQuery = false;

    this.filteredPassenger = [];

    this.tripDet.controls['tripiPassenger'].setValue('0');

    // this.tripDet.controls['safir'].setValue(strName);

    this.tripDet.controls['strMobile'].setValue('');

    setTimeout(() => {

      (document.getElementById('tripPassenger') as HTMLInputElement).readOnly = false;

    }, 10);


  }

  searchSafir(event: any) {

    if (event.target.value.length < 1) {

      this.filteredPassenger = [];

      this.tripDet.controls['tripiPassenger'].setValue('');

    }

    this.hasQuery = true;

    this.filteredPassenger = this.passengers.filter((x: any) => x.strFullName.startsWith(event.target.value) || x.strMobile.startsWith(event.target.value));
  }

  async getPassengers() {

    var model = this.otherServices.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    })

    let res = JSON.parse((await axios.post(`Passenger_List`, model)).data.toString());

    this.passengers = res;

    this.isLoading = false;

  }

  async getTripReasons() {

    let res = JSON.parse((await axios.post(`TripReason_List`, {})).data.toString());

    this.tripReasons = res;

    this.isLoading = false;

  }

  async getVehicleTypes() {
    let res = JSON.parse((await axios.post(`MobileType_List`, {})).data.toString());
    this.vehicleTypes = res;
  }

  async getTripImportance() {

    this.isLoading = true;

    let res = JSON.parse((await axios.post(`TripImportance_List`, {})).data.toString());

    this.tripImportance = res;

    // console.log(res)

  }

  async searchPassenger(strContent: string) {

    this.isPassengerLoading = true;

    var model = this.otherServices.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      strContent: strContent

    })

    let res = JSON.parse((await axios.post(`Passenger_Search`, model)).data.toString());

    this.passengers = res;

    this.hasQuery = true;

    this.filteredPassenger = this.passengers;

    this.isPassengerLoading = false;

  }

  setType(id: any) {

    let current = <HTMLElement>document.getElementById(String(this.menuType));

    current?.classList.remove('active');

    this.menuType = id;

    let element = <HTMLElement>document.getElementById(String(this.menuType));

    element.classList.add('active');

  }

  change_TripType(tiType: 'bHaveReturn' | 'bExclusive' | 'bMissionary' | 'sideway') {

    // رفت و برگشت

    if (tiType == 'bHaveReturn') {

      this.bExclusive = false;

      this.bMissionary = false;

      this.bHaveReturn = true;

    }

    // در اختیار

    else if (tiType == 'bExclusive') {

      this.bHaveReturn = false;

      this.bMissionary = false;

      this.bExclusive = true;

    }

    // مأموریتی

    else if (tiType == 'bMissionary') {

      this.bHaveReturn = false;

      this.bExclusive = false;

      this.bMissionary = true;

    }

    // یک طرفه

    else {

      this.bExclusive = false;

      this.bMissionary = false;

      this.bHaveReturn = false;


    }

  }

  async openBusyRoutes(tiType: 1 | 2) {

    if (!this.lst_TripSAD.length) {

      var model = this.otherServices.stringNumberToNumber({

        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      })

      let res = JSON.parse((await axios.post(`TripSAD_List`, model)).data.toString());

      this.lst_TripSAD = res;

      this.lst_TripSAD_Search = res;

      this.obj_TripSAD = { tiType: tiType }

      this.isBusyRoutes = true;

    }

    else {

      this.lst_TripSAD = this.lst_TripSAD_Search;

      this.obj_TripSAD = { tiType: tiType }

      this.isBusyRoutes = true;

    }

  }

  selectTripSAD(item: any, isConfirm: boolean) {

    // اکر آدرس انتخاب شده باشد

    if (isConfirm) {

      if (!this.obj_TripSAD.iTripSAD) return this.notificationService.showError('آدرس خود را انتخاب کنید');

      else {

        // آدرس مبداء

        if (this.obj_TripSAD.tiType == 1) {

          this.origin = this.obj_TripSAD;

          this.path.controls['origin'].setValue(this.obj_TripSAD.strAddress);

          this.path.controls['olatIn'].setValue(this.obj_TripSAD.fLat);

          this.path.controls['olongIn'].setValue(this.obj_TripSAD.fLon);

          this.isBusyRoutes = false;

        }

        // آدرس مقصد

        else {

          this.destination = this.obj_TripSAD;

          this.path.controls['destination'].setValue(this.obj_TripSAD.strAddress);

          this.path.controls['dlatIn'].setValue(this.obj_TripSAD.fLat);

          this.path.controls['dlongIn'].setValue(this.obj_TripSAD.fLon);

          this.isBusyRoutes = false;

        }

      }

    }

    // اگر روی آدرس کلیک کرد

    else {

      this.obj_TripSAD = { ...this.obj_TripSAD, ...item };

    }

  }

  filter_list(val: any) {

    this.lst_TripSAD = this.lst_TripSAD_Search.filter((el: any) => {

      return el.strName.includes(val.value) ||

        el.strAddress.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_TripSAD = this.lst_TripSAD_Search;

    }

  }

}
